import { validityCheck, logout } from '@/api/auth'
import { updateProfile } from '@/api/profile'
import { clearAuthCookies } from '@/helpers/auth'

const state = {
  currentUser: null,
}

export const getters = {
  getCurrentUser: $state => $state.currentUser,
  isLoggedIn: $state => Boolean($state.currentUser),
  // Spec 2: flexible per-user rights; administrators hold every permission
  hasPermission: $state => permission => {
    const user = $state.currentUser
    if (!user) return false
    if (user.role === 'administrator') return true
    return (user.accounts?.[0]?.permissions || []).includes(permission)
  },
}

export const actions = {
  async validityCheck({ commit }) {
    try {
      const response = await validityCheck()
      commit('SET_CURRENT_USER', response.data.payload.data)
    } catch (error) {
      if (error?.response?.status === 401) {
        clearAuthCookies()
        window.location = '/app/login'
      }
    }
  },
  async updateProfile({ commit }, payload) {
    const response = await updateProfile(payload)
    commit('SET_CURRENT_USER', response.data)
    return response.data
  },
  async logout() {
    await logout()
  },
}

export const mutations = {
  SET_CURRENT_USER($state, user) {
    $state.currentUser = user
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
